import {useState} from 'react';

import mwSettingsService from '@/services/mw/mwSettingsService';
import {hideLoader, showLoader} from '@/state/slices/loadersSlice';
import {dispatch} from '@/state/store';

import {useIlluminationModeContent} from './useIlluminationModeContent';
import {useIlluminationModeHandlers} from './useIlluminationModeHandlers';

export const useIlluminationMode = () => {
    const content = useIlluminationModeContent();
    const {type, notifications, popup, popupCurrentValue} = content || {};
    const {type: currentType} = popupCurrentValue || {};
    const [uiLedIntensity, setUiLedIntensity] = useState(currentType);

    const resetUIState = () => {
        setUiLedIntensity(currentType);
    };

    const updateIlluminationMode = (popupValueType, onSuccess, onError) => {
        mwSettingsService.updateDeviceSettings({
            settingType: type,
            data: {
                [popupValueType]: true,
            },
            onUpdateStart: () => dispatch(showLoader()),
            onSuccess: () => {
                dispatch(hideLoader());
                onSuccess(popupValueType);
            },
            onError: () => {
                dispatch(hideLoader());
                onError(popupValueType);
            },
        });
    };

    const onSave = () => {
        updateIlluminationMode(uiLedIntensity, handleSuccess, handleError);
    };

    const {handleSuccess, handleError} = useIlluminationModeHandlers({
        notifications,
        popup,
        resetUIState,
        setUiLedIntensity,
        updateIlluminationMode: onSave,
    });

    const onChange = (newPopupValue) => {
        setUiLedIntensity(newPopupValue);
    };

    return {
        content,
        onChange,
        onSave,
        value: uiLedIntensity,
    };
};
